
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';
import { useCheckoutStore } from '@/stores/checkoutStore';

const CustomerInfoSection = () => {
  const { email, phone, needsInvoice, setField, toggleInvoice } = useCheckoutStore();
  
  return (
    <Card id="customer-info" className="scroll-mt-24">
      <CardHeader className="pb-3">
        <CardTitle className="text-gray-700">1. Ostja andmed</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email" className="text-gray-600">
            E-post*
          </Label>
          <Input
            id="email"
            type="email"
            placeholder="nimi@example.com"
            value={email}
            onChange={(e) => setField('email', e.target.value)}
            required
            className="w-full"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="phone" className="text-gray-600">
            Telefon
          </Label>
          <Input
            id="phone"
            type="tel"
            placeholder="+372 512 3456"
            value={phone}
            onChange={(e) => setField('phone', e.target.value)}
            className="w-full"
          />
        </div>
        
        <div className="flex items-center space-x-2 pt-2">
          <Checkbox 
            id="needsInvoice" 
            checked={needsInvoice}
            onCheckedChange={() => toggleInvoice()}
          />
          <Label 
            htmlFor="needsInvoice" 
            className="text-sm cursor-pointer"
          >
            Soovin arvet ettevõttele
          </Label>
        </div>
      </CardContent>
    </Card>
  );
};

export default CustomerInfoSection;
